module.exports = __webpack_public_path__ + "static/media/schiphol-icons.b950b50b.eot";